'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import { PromotionInfoMap, PromotionType } from '@headless-workspace/domain/common/server';
import { Component } from '@headless-workspace/typings';

type ProductDetailPromotionsInformationContextType = {
    promotionInfosMap?: PromotionInfoMap;
};

type ProductDetailPromotionsInformationProviderProps = ProductDetailPromotionsInformationContextType &
    PropsWithChildren;

const ProductDetailPromotionsInformationContext = createContext<ProductDetailPromotionsInformationContextType>({
    promotionInfosMap: undefined,
});

export const ProductDetailPromotionsInformationProvider: Component<ProductDetailPromotionsInformationProviderProps> = ({
    promotionInfosMap,
    children,
}) => {
    return (
        <ProductDetailPromotionsInformationContext.Provider value={{ promotionInfosMap }}>
            {children}
        </ProductDetailPromotionsInformationContext.Provider>
    );
};

type ProductDetailPromotionsInformationProps = {
    promotion?: PromotionType;
};
export const useProductDetailPromotionsInformation = ({ promotion }: ProductDetailPromotionsInformationProps) => {
    const { promotionInfosMap } = useContext(ProductDetailPromotionsInformationContext);
    if (!promotion) {
        return undefined;
    }
    return promotionInfosMap?.[promotion];
};
